import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { fonts, responsiveText, spacing } = theme;

export const root = css`
  padding: ${spacing.xxl}px ${spacing.lg}px;
  color: var(--neutral-black-base);

  h2 {
    margin: 0 0 ${spacing.md}px 0;
    font-family: ${fonts.PRIMARY_SEMIBOLD.family};
    font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
    ${responsiveText.HEADING.XS};
  }

  p {
    margin: 0 0 ${spacing.md}px 0;
    max-width: 644px;
    font-family: ${fonts.PRIMARY_REGULAR.family};
    font-weight: ${fonts.PRIMARY_REGULAR.weight};
    ${responsiveText.BODY.SM};

    &:last-of-type {
      margin: 0;
    }
  }
`;
